import { numberMetricFormat } from "./numbers";

// Función de utilidad para renderizar métricas complejas
export const renderMetricValue = (value, metricKey, currency = "USD") => {
  if (value === undefined || value === null) return "N/A";

  if (metricKey === "costPerMainAction") {
    const numValue = Number(value);
    if (!Number.isFinite(numValue) || numValue <= 0) return "-";
    return `${numberMetricFormat(numValue)} ${currency}`;
  }

  // Si es un array
  if (Array.isArray(value)) {
    if (value.length === 0) return "N/A";

    // Si el primer elemento es un objeto con action_type y value
    if (
      value[0] &&
      typeof value[0] === "object" &&
      value[0].action_type &&
      value[0].value !== undefined
    ) {
      if (metricKey === "costPerActionType" || metricKey === "actions") {
        const total = value.reduce((sum, item) => {
          const numValue = parseFloat(item.value);
          return sum + (isNaN(numValue) ? 0 : numValue);
        }, 0);
        return numberMetricFormat(total);
      } else {
        const numValue = parseFloat(value[0].value);
        if (isNaN(numValue)) return "N/A";
        if (metricKey.includes("cost") || metricKey.includes("spend")) {
          return `${numberMetricFormat(numValue)} ${currency}`;
        } else if (
          metricKey.includes("ctr") ||
          metricKey.includes("rate") ||
          metricKey.includes("videoHookRate") ||
          metricKey.includes("videoRetentionRate")
        ) {
          return `${numberMetricFormat(numValue)}%`;
        } else {
          return numberMetricFormat(numValue);
        }
      }
    }

    // Si el primer elemento es un objeto con indicator y values
    if (
      value[0] &&
      typeof value[0] === "object" &&
      value[0].indicator &&
      value[0].values
    ) {
      if (
        value[0].values.length > 0 &&
        value[0].values[0].value !== undefined
      ) {
        const numValue = parseFloat(value[0].values[0].value);
        if (isNaN(numValue)) return "N/A";
        if (metricKey === "resultRate") {
          return `${numberMetricFormat(numValue)}%`;
        } else if (metricKey === "results") {
          return numberMetricFormat(numValue);
        } else {
          return numberMetricFormat(numValue);
        }
      }
      return "N/A";
    }

    // Si es un array de strings o números
    if (typeof value[0] === "string" || typeof value[0] === "number") {
      const numValue = parseFloat(value[0]);
      if (isNaN(numValue)) return "N/A";
      return numberMetricFormat(numValue);
    }

    return "N/A";
  }

  // Si es un string
  if (typeof value === "string") {
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      if (
        metricKey.includes("cost") ||
        metricKey.includes("spend") ||
        metricKey.includes("revenue") ||
        metricKey.includes("value") ||
        metricKey.includes("billedCost") ||
        metricKey.includes("socialSpend") ||
        metricKey.includes("cpm") ||
        metricKey.includes("cpc")
      ) {
        return `${numberMetricFormat(numValue)} ${currency}`;
      } else if (
        metricKey.includes("rate") ||
        metricKey.includes("ctr") ||
        metricKey.includes("engagementRate") ||
        metricKey.includes("conversionRate") ||
        metricKey.includes("resultRate") ||
        metricKey.includes("videoHookRate") ||
        metricKey.includes("videoRetentionRate")
      ) {
        return `${numberMetricFormat(numValue)}%`;
      } else {
        return numberMetricFormat(numValue);
      }
    }
    return value;
  }

  // Si es un número
  if (typeof value === "number") {
    if (
      metricKey.includes("cost") ||
      metricKey.includes("spend") ||
      metricKey.includes("revenue") ||
      metricKey.includes("value") ||
      metricKey.includes("billedCost") ||
      metricKey.includes("socialSpend") ||
      metricKey.includes("cpm") ||
      metricKey.includes("cpc")
    ) {
      return `${numberMetricFormat(value)} ${currency}`;
    }
    if (
      metricKey.includes("rate") ||
      metricKey.includes("ctr") ||
      metricKey.includes("engagementRate") ||
      metricKey.includes("conversionRate") ||
      metricKey.includes("resultRate") ||
      metricKey.includes("videoHookRate") ||
      metricKey.includes("videoRetentionRate")
    ) {
      return `${numberMetricFormat(value)}%`;
    }
    return numberMetricFormat(value);
  }

  // Si es un objeto, intentar extraer un valor
  if (typeof value === "object" && value !== null) {
    if (value.value !== undefined) {
      return renderMetricValue(value.value, metricKey, currency);
    }
    return "N/A";
  }

  return String(value);
};
